export const formatFileSize = (bytes) => {
    if (bytes === 0)
        return '0 B';
    const k = 1024;
    const sizes = ['B', 'KB', 'MB', 'GB'];
    const i = Math.floor(Math.log(bytes) / Math.log(k));
    const size = bytes / Math.pow(k, i);
    return `${size.toFixed(i === 0 ? 0 : 2)}${sizes[i]}`;
};
export const formatDate = (date) => {
    return new Intl.DateTimeFormat('pt-BR', {
        day: '2-digit',
        month: '2-digit',
        year: 'numeric',
    }).format(date);
};
export const formatAcceptText = (types) => {
    if (types.length === 1)
        return `.${types[0]}`;
    if (types.length === 2)
        return `.${types[0]} e .${types[1]}`;
    return types
        .map((t, i) => (i === types.length - 1 ? `e .${t}` : `.${t}, `))
        .join('')
        .replace(', e', ' e');
};
export const getFileName = (value) => {
    if (!value)
        return '';
    return typeof value === 'string' ? (value.split('/').pop() ?? '') : value.name;
};
